// Single source of truth for "does this posting carry usable pay?".
//
// This lives outside Compensation on purpose. The step used to publish its
// verdict into the form-wide `validation` flag, and the parent form's own
// `useEffect([jobState])` then overwrote that flag with `false` for any
// non-temp job whose position/type/practice were filled in. The pay gate was
// silently cleared, the rail let the poster jump straight to Description, and
// a job with no pay could be submitted.
//
// Deriving the answer from jobState in both places removes the flag race
// entirely: there is nothing left to clobber, and the parent knows the answer
// before Compensation mounts (react-tabs only renders the selected panel, so a
// value pushed up from the step would not exist on step 1 of an edit).
//
// Mirrors Job#listed_pay_valid? on the server.
export interface PayFields {
  min_compensation?: unknown;
  compensation?: unknown;
  exact_pay?: unknown;
  // The job-form state carries dozens of other keys. The index signature also
  // keeps this off TypeScript's "weak type" check, which would otherwise
  // reject a jobState that happens to declare none of the three by name.
  [key: string]: unknown;
}

const filled = (value: unknown) =>
  value !== null && value !== undefined && value !== "" && Number(value) > 0;

export function payIsValid(job: PayFields): boolean {
  // An exact amount is a single figure. The React form writes it to
  // min_compensation; the assistant writes it to compensation. Either counts.
  if (job.exact_pay) return filled(job.min_compensation) || filled(job.compensation);

  return (
    filled(job.min_compensation) &&
    filled(job.compensation) &&
    Number(job.compensation) >= Number(job.min_compensation)
  );
}
